export default __webpack_public_path__ + "static/media/close-icon.85f9f2a1.svg";